import { createClient } from '@supabase/supabase-js';


// Initialize Supabase client
// Using direct values from project configuration
const supabaseUrl = 'https://ggavtngjpeppxzdahgwx.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdnYXZ0bmdqcGVwcHh6ZGFoZ3d4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAyNDUyNzIsImV4cCI6MjA2NTgyMTI3Mn0.RHohfXzaIPDfqwYQnxiF12FTw8XaUZdk0SvxNWycE8U';
const supabase = createClient(supabaseUrl, supabaseKey);


export { supabase };